import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './styles.css'; // Si tienes un archivo CSS para estilos, agrégalo aquí

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <App />
);
